import {
  CNavItem,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
} from "@coreui/react-pro";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { matchPath } from "react-router-dom";
import { RootState } from "../../reducers";
import { useRouter } from "../../shared/utils/hooks/useRouter";
import Logo from "../shared/icons/sidebar/Logo";
import LogoFull from "../shared/icons/sidebar/LogoFull";
import { SidebarItem, defaultSiderbarItems } from "./NavItems";
import { toggleSidebar } from "./reducer";
import noti from "../../assets/noti.mp3";
import { socket } from "@/shared/config/socket";

interface ICustomCNavItem {
  href: string;
  target?: string;
  customClassname?: string;
  children: React.ReactNode;
}

export const CustomCNavItem = ({
  href,
  children,
  customClassname,
  target,
}: ICustomCNavItem) => {
  const { location } = useRouter();
  const isActive = matchPath({ path: href, end: false }, location.pathname);
  return (
    <CNavItem
      href={`#${href}`}
      target={target}
      active={Boolean(isActive)}
      className={`${customClassname || ""} text-break dummy`}
    >
      {children}
    </CNavItem>
  );
};

const TheSidebar = () => {
  const dispatch = useDispatch();
  const { redirectView, location } = useRouter();
  const { pathname } = location;
  const containerState = useSelector((state: RootState) => state.container);
  const { sidebarShow } = containerState;
  const [sidebarItems, setSidebarItems] = useState<SidebarItem[]>([]);
  const audioRef: any = useRef(null);

  useEffect(() => {
    // const sidebarItems = handleSidebarItemsOnPathName(pathname);
    setSidebarItems(defaultSiderbarItems || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderSidebarItems = (items: SidebarItem[]) => {
    return items.map((item) => {
      return (
        <CustomCNavItem href={item.to} key={item.name} customClassname={""}>
          {item.icon}
          {item.name}
          {item?.count && (
            <span className="badge rounded-pill bg-danger">{item?.count}</span>
          )}
        </CustomCNavItem>
      );
    });
  };
  useEffect(() => {
    socket.on(`transaction_seen`, (res: any) => {
      if (res.transaction || res.room) {
        audioRef.current.play().catch((error: any) => {
          console.log("Audio play failed:", error);
        });
      } else {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      if (res.room) {
        setSidebarItems((prevItems) =>
          prevItems.map((item, index) => {
            if (index === 3) return { ...item, count: res.room };
            return item;
          })
        );
        return;
      }
    });

    return () => {
      socket.off("transaction_seen");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CSidebar
      className="custom-sidebar"
      position="fixed"
      visible={sidebarShow}
      onVisibleChange={(val: boolean) => dispatch(toggleSidebar(val))}
    >
      <audio ref={audioRef} src={noti} />
      <CSidebarBrand
        className="sidebar-brand d-none d-md-flex cursor-pointer"
        onClick={redirectView("/")}
      >
        <h6 style={{ margin: 0, fontWeight: 600 }}>ADMIN</h6>
      </CSidebarBrand>
      <CSidebarNav>{renderSidebarItems(sidebarItems)}</CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
